import {
  Button,
  Label,
  ListBox,
  ListBoxItem,
  ListBoxItemProps,
  Popover,
  Select,
} from "react-aria-components";
import { FaCaretDown, FaCheck } from "react-icons/fa";
import { getFirstDayOfWeek } from "../../utils/date-utils";
import { useState } from "react";
import DatePickerUi from "../../common/DatePickerUi";

interface Option {
  label: string;
  value: string;
}

type DropdownInputProps = {
  label?: string;
  name?: string;
  options?: Option[];
  disabled?: boolean;
  onChange?: (e: any) => void;
  onChangeCustom?: (e: any) => void;
  defaultValue?: string | any;
  errorMessage?: string;
  description?: string;
  placeHolder?: string;
  isDatePickerOpen?: boolean;
  isAgent?: boolean;
  isNewUsers?: boolean;
};

function SelectDropdown({
  label,
  name,
  options,
  disabled,
  onChange,
  onChangeCustom,
  defaultValue,
  errorMessage,
  description,
  placeHolder,
  isAgent = false,
  isNewUsers,
  ...props
}: DropdownInputProps) {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  // const handleRangeChange = (field: "from" | "to", value: any) => {
  //   onChangeCustom((prev: any) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };
  return (
    <Select
      className={`w-full`}
      isDisabled={disabled}
      selectedKey={defaultValue}
      onSelectionChange={onChange}
      {...props}
    >
      <Label
        htmlFor={name}
        // className="block text-sm font-medium leading-6 text-gray-900"
        className="sr-only"
      >
        {label}
      </Label>
      <Button
        className={` w-full rounded-md border-0 py-1.5 text-[#323232] shadow-sm ring-1 ring-inset ring-gray-300  focus:outline focus:outline-2 focus:outline-[#3F81FE] sm:max-w-xs sm:text-sm sm:leading-6 flex items-center justify-between px-3 hover:outline hover:outline-2 hover:outline-[#3F81FE] `}
      >
        <span
          className={`flex-1 truncate  text-left text-[#323232] placeholder:text-gray-400
          `}
        >
          {["Select user", "Select Mail Type"].includes(placeHolder ?? "") ? options?.find(opt => opt.value === defaultValue)?.label || placeHolder : defaultValue}
        </span>
        <FaCaretDown className="text-gray-500 size-5" />
      </Button>
      <Popover className="w-[--trigger-width] rounded-md bg-white text-base shadow-lg ring-1 ring-black/5 entering:animate-in entering:fade-in exiting:animate-out exiting:fade-out">
        <ListBox className="max-h-[350px] overflow-y-auto outline-none px-1"
          style={{
            scrollbarWidth: "thin",
            scrollbarColor: "#d1d5db #f3f4f6",
          }}
        >
          {options?.map((option: Option) => {
            return (
              <FilterDate
                id={option.value}
                key={option.value}
                textValue={option.value}
              >
                {option.label}
              </FilterDate>
            );
          })}
        </ListBox>
        {!isAgent && !isNewUsers && (
          <div className="outline-none px-1">
            <button
              onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}
              className=" group flex items-center gap-2 cursor-default select-none py-2 px-4 outline-none rounded text-gray-900 focus:bg-[#3F81FE] focus:text-white w-full text-left"
            >
              <span> Custom Date</span>

              {/* {isDatePickerOpen && (
              <span className="flex items-center">
                <FaCheck className="w-4 h-4 text-[#3F81FE] group-focus:text-white" />
              </span>
            )} */}
            </button>
          </div>
        )}
        <div>
          {isDatePickerOpen && (
            <div className="p-0">
              <DatePickerUi
                name="date_range"
                isRequired={false}
                defaultValue={getFirstDayOfWeek}
                onChange={onChangeCustom}
              />
            </div>
          )}
        </div>
        {/* )} */}
      </Popover>
    </Select>
  );
}

export default SelectDropdown;

function FilterDate(props: ListBoxItemProps & { children: React.ReactNode }) {
  return (
    <ListBoxItem
      {...props}
      className="group flex items-center gap-2 cursor-default select-none py-2 px-4 outline-none rounded text-gray-900 focus:bg-[#3F81FE] focus:text-white"
    >
      {({ isSelected }) => (
        <>
          <span className="flex-1 flex items-center gap-2 truncate font-normal group-selected:font-medium">
            {props.children}
          </span>
          <span className="w-5 flex items-center text-rose-600 group-focus:text-white">
            {isSelected && (
              <FaCheck className="w-4 h-4 text-[#3F81FE] group-focus:text-white" />
            )}
          </span>
        </>
      )}
    </ListBoxItem>
  );
}
